/**
 * Define the media queries sizes for different platforms (mobile/tablet/desktop),
 * https://jsramblings.com/2018/02/04/styled-components-media-queries.html
 */
export const device = {
  // Mobile settings
  isMobile: '(max-width: 700px)',
  // isSmallMobile: '(max-width: 329px)',
  // isMediumMobile: '(min-width: 330px) and (max-width: 479px)',
  // isMediumMobileAndUnder: '(max-width: 479px)',
  // isLargeMobile: '(min-width: 480px) and (max-width: 639px)',

  // Table settings
  isTablet: '(min-width: 701px) and (max-width: 1024px)',
  isTabletAndAbove: '(min-width: 701px)',
  // isSmallTabletAndUnder: '(max-width: 767px)',
  // isSmallTabletAndUnder: '(max-width: 767px)',
  // isSmallTablet: '(min-width: 640px) and (max-width: 767px)',
  // isLargeTablet: '(min-width: 768px) and (max-width: 1023px)',

  // Desktop settings
  isDesktop: '(min-width: 1025px)'
  // isSmallDesktopAndUnder: '(max-width: 1243px)',
  // isSmallDesktop: '(min-width: 1025px) and (max-width: 1243px)',
  // isMediumDesktop: '(min-width: 1244px) and (max-width: 1409px)',
  // isLargeDesktop: '(min-width: 1410px)'
};

export default device;
